import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-date-pipe-page-ui',
    templateUrl: './bb-date-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DatePageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
